export default __webpack_public_path__ + "static/media/planticon_2.cbc349ad.png";